import { Helmet as BaseHelmet } from "react-helmet";
import { brands } from "../data";
import { useBrandContext } from "../App";

export const Helmet = ({ title }) => {
  const { brand } = useBrandContext();
  const favicon = brands[brand].favicon;
  return (
    <BaseHelmet>
      <title>{title}</title>
      <link rel="canonical" href={window.location.href} />
      <link
        rel="icon"
        href={favicon}
      />
      <link rel="apple-touch-icon" href={favicon} />
      <meta property="og:image" content={favicon} />
      <link rel="icon" href={favicon} />
    </BaseHelmet>
  );
};
